import { Component, HostListener, Input } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { PeuPayments } from '../../models/peu-payment.model';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-peu-table',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './peu-table.component.html',
  styleUrl: './peu-table.component.scss'
})
export class PeuTableComponent {
  @Input() payment: PeuPayments;
  @Input() titleAsH1 = false;
  content: {
    type: string;
    price: string;
    units: string;
    taxFee: string;
    postalFee: string;
    signatureFee: string;
    administrativeFee: string;
    priceSum: string;
  };
  isMobile: boolean;

  constructor(private translate: TranslateService) { }

  ngOnInit(): void {
    this.translate.get('PEU_PAYMENTS.CART_LIST').subscribe({
      next: (content: any) => (this.content = content)
    });

    this.checkIsMobile();
  }

  feeChecker(fee: string): boolean {
    return this.payment.items.some(el => el[fee] !== null && el[fee] !== undefined);
  }

  @HostListener('window:resize', ['$event'])
  checkIsMobile() {
    if (window.innerWidth <= 576) {
      this.isMobile = true;
    } else {
      this.isMobile = false;
    }
  }
}
